// ============================================
// メガメニュー
// ============================================

export default function initHeader() {
  megaMenu();
}

function megaMenu() {
  const btn = document.querySelectorAll(".js-mega-menu-btn");
  const body = document.body;

  btn.forEach((btn) => {
    const drawerId = btn.getAttribute("aria-controls");
    const drawer = document.getElementById(drawerId);

    if (drawer) {
      let isHovered = false;
      let isClosing = false; // 閉じる処理中かどうかを判定するフラグ
      let shouldFocusOnButton = false; //ボタンにフォーカスを戻すかどうかを判定するフラグ

      // フォーカス可能な要素の選択
      const focusableSelectors = ["a[href]", "button:not([disabled])", '[tabindex]:not([tabindex="-1"])'];

      // タブ移動
      const trapFocus = (event) => {
        const focusableElements = Array.from(drawer.querySelectorAll(focusableSelectors.join(",")));
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.key === "Tab") {
          if (event.shiftKey) {
            // Shift + Tab: 逆方向
            if (document.activeElement === firstFocusable) {
              event.preventDefault();
              lastFocusable.focus();
            }
          } else {
            // Tab: 順方向
            if (document.activeElement === lastFocusable) {
              event.preventDefault();
              firstFocusable.focus();
            }
          }
        }
      };

      // モーダルオープン
      const openDrawer = (byHover = false) => {
        if (isClosing) return; // 閉じる処理中の場合はオープンしない
        drawer.setAttribute("inert", "true"); // フォーカス制御を一時的に無効化
        drawer.show();
        drawer.removeAttribute("inert"); // フォーカス制御を再有効化
        btn.setAttribute("aria-expanded", "true");
        btn.classList.add("is-active");
        drawer.setAttribute("aria-hidden", "false");
        drawer.classList.add("is-visible");
        isHovered = true;
        shouldFocusOnButton = false;

        // ホバーで開いた場合はフォーカスを当てない
        if (!byHover) {
          const focusableElements = Array.from(drawer.querySelectorAll(focusableSelectors.join(",")));
          if (focusableElements.length > 0) {
            focusableElements[0].focus(); // 最初のフォーカス可能な要素にフォーカス
          }
        }

        // モーダル内でタブ移動を制限
        document.addEventListener("keydown", trapFocus);
      };

      // モーダルクローズ
      const closeDrawer = () => {
        isClosing = true; // 閉じる処理中
        btn.setAttribute("aria-expanded", "false");
        btn.classList.remove("is-active");
        drawer.setAttribute("aria-hidden", "true");
        drawer.classList.remove("is-visible");

        setTimeout(() => {
          drawer.close();
          if (shouldFocusOnButton) {
            btn.focus(); // フォーカスをボタンに戻す
          }

          body.classList.remove("is-no-scroll");
          isClosing = false; // 閉じる処理フラグを解除
        }, 200);

        // タブ移動制限を解除
        document.removeEventListener("keydown", trapFocus);
      };

      // ボタンクリック時の挙動（タブレット対応）
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        if (btn.getAttribute("aria-expanded") === "true") {
          // 既に開いている場合は閉じる
          isHovered = false;
          closeDrawer();
        } else {
          // 開いていない場合は開く
          openDrawer();
        }
      });

      // フォーカスが当たったときにモーダルを開く（Tabキー対応）
      btn.addEventListener("focus", () => {
        if (!drawer.classList.contains("is-visible")) {
          openDrawer();
        }
      });

      // 閉じるボタンクリックで閉じる
      const closeBtn = drawer.querySelector(".js-mega-menu-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", (event) => {
          isHovered = false; // ホバー状態を解除
          shouldFocusOnButton = true; // フォーカスをボタンに戻すフラグを設定
          closeDrawer();
        });
      }

      // `btn`にマウスが入ったときにダイアログを開く
      btn.addEventListener("mouseenter", openDrawer);

      // `drawer`にマウスが入ったとき
      drawer.addEventListener("mouseenter", () => {
        isHovered = true; // ホバー状態を維持
      });

      // `btn`からマウスが出たとき
      btn.addEventListener("mouseleave", () => {
        isHovered = false; // ホバー状態を解除
        setTimeout(() => {
          if (!isHovered) closeDrawer();
        }, 50);
      });

      // `drawer`からマウスが出たとき
      drawer.addEventListener("mouseleave", () => {
        isHovered = false; // ホバー状態を解除
        setTimeout(() => {
          if (!isHovered) closeDrawer();
        }, 50);
      });

      //escキーで閉じる
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          isHovered = false; // ホバー状態を解除
          closeDrawer();
        }
      });
    }
  });
}
